import type { FaireReviewEntity } from "../../entity_types/review";

// Real per-product review for LE LIS's "LONG SLEEVE CREW NECK POLKA DOT
// SWEATER CARDIGAN" (p_sy5zkh37xf), read from GET /api/product-reviews/
// product/p_sy5zkh37xf (the same data source that powers the product's own
// PDP review list) — verbatim comment, real reviewer, real rating, real
// publish date.
export const review_ll5: FaireReviewEntity = {
  token: "review_ll5",
  type: "review",
  brandName: "LE LIS",
  brandToken: "b_q8gu9by5sv",
  productToken: "p_sy5zkh37xf",
  reviewType: "product",
  reviewerName: "Melissa M.",
  reviewerLocation: "Texarkana, TX",
  stars: 5,
  reviewText: "A bit oversized for my liking but overall great product.",
  reviewDate: "Mar 27, 2026",
  meta: {
    source: "api",
    importedAt: "2026-08-13T17:05:56.758Z",
    importedBy: "entity-db-cli",
  },
};
